<template>
  <Input
    :type="passwordVisible ? 'text' : 'password'"
    :icon1="icon"
    :form="form"
    @input="$emit('input', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @icon-click="toggleVisibility"
  />
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';
import Input from 'Components/01-atoms/form/input/Input.vue';
import { formMixin } from 'Libs/mixins/formMixin';

export default {
  name: 'Password',
  components: { Input },
  mixins: [globalMixin, formMixin],
  data() {
    return {
      passwordVisible: false,
    };
  },
  computed: {
    icon() {
      return this.passwordVisible
        ? { icon: 'Visibility' }
        : { icon: 'VisibilityOff' };
    },
  },
  methods: {
    toggleVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
  },
};
</script>
